import { isLogicGroup } from 'customer-data-filters-ui/filterQueryFormat/logic/LogicGroup';
import { Fragment, useMemo } from 'react';
import { List } from 'immutable';
import FiltersDisplayCondition from './FiltersDisplayCondition';
import FiltersDisplayRelatedConditions from './FiltersDisplayRelatedConditions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConditionsContainer = styled.div.withConfig({
  displayName: "FiltersDisplayConditionsGroupConditions__ConditionsContainer",
  componentId: "sc-1syg77n-0"
})(({
  theme
}) => ({
  '> * + *': {
    marginTop: theme.space[200]
  }
}));
const FiltersDisplayConditionsGroupConditions = props => {
  const {
    logicGroup,
    logicGroupIndex
  } = props;
  const logicGroupConditionsSeq = useMemo(() => logicGroup.conditions.entrySeq(), [logicGroup]);
  const baseFilterFamily = logicGroup.filterFamily;
  return /*#__PURE__*/_jsx(ConditionsContainer, {
    children: logicGroupConditionsSeq.map(([key, condition], index) => {
      const conditionPath = List([logicGroupIndex, key]);
      /*  Render child filter branches */
      if (isLogicGroup(condition)) {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [index !== 0 && /*#__PURE__*/_jsxs(View, {
            marginBlockStart: "250",
            marginBlockEnd: "250",
            children: [' ', /*#__PURE__*/_jsx(FormattedMessage, {
              message: `customerDataFiltersUI.customerDataFilters.FilterEditorOperatorDisplayList.and`
            })]
          }), /*#__PURE__*/_jsx(FiltersDisplayRelatedConditions, {
            conditionPath: conditionPath,
            logicGroup: condition
            // @ts-expect-error logicGroupName technically might be undefined
            ,
            parentLogicGroupOperator: logicGroup.logicGroupName
          })]
        }, index);
      }

      /* Render branch filters */
      return /*#__PURE__*/_jsx(FiltersDisplayCondition, {
        condition: condition,
        filterFamily: baseFilterFamily,
        conditionPath: conditionPath,
        isFirst: index === 0,
        parentLogicGroup: logicGroup
      }, index);
    })
  });
};
export default FiltersDisplayConditionsGroupConditions;